import {AxiosResponse} from 'axios'
import Api from '../api'

export default (memberId: number): Promise<AxiosResponse> => {
    if (memberId === undefined) {
        console.warn('Listing ID is undefined');
        return Promise.reject();
      }
  const path = `/account/membership/v3/by-id/${memberId}`
  return Api.getInstance(false, false, process.env.REACT_APP_API_SUB_URL).request.get(
    `${path}`,
    path
  )
}
